/**
 * Cliente de Autorización/Captura · Sprint 59 · F2A.
 *
 * Solicita el pago UNA sola vez tras completar 3DS. El frontend NUNCA decide
 * APPROVED ni FINALIZED: sólo refleja el estado que devuelve el backend.
 * NO guarda billTo, tokens ni material 3DS en URL/localStorage/sessionStorage.
 */
import { CODIGOS_ESTADO_MX } from "@/constants/direccionBanco";
import { api } from "@/services/api";

const _err = (e) => ({
  error: e?.response?.data?.detail || "network_error",
  status: e?.response?.status || 0,
});

export const authorizeF2A = async (compraId, sessionId, billTo) => {
  try {
    const { data } = await api.post("/pagos/f2a/authorize", {
      compraId,
      sessionId,
      billTo,
    });
    return data;
  } catch (e) {
    return _err(e);
  }
};

export const statusF2A = async (compraId) => {
  try {
    const { data } = await api.get("/pagos/f2a/status", { params: { compraId } });
    return data;
  } catch (e) {
    return _err(e);
  }
};

/**
 * Reanuda la finalización LOCAL de un intento APPROVED tras F5/caída.
 * Idempotente y SIN reenviar el pago: el backend sólo emite boletos y marca
 * FINALIZED si el intento activo está APPROVED. No envía billTo ni tokens.
 */
export const finalizeF2A = async (compraId) => {
  try {
    const { data } = await api.post("/pagos/f2a/finalize", { compraId });
    return data;
  } catch (e) {
    return _err(e);
  }
};

/** Validación mínima en cliente (el backend es autoritativo). */
export const validarBillTo = (bt) => {
  const errores = {};
  if (!bt.address1 || bt.address1.trim().length < 3) errores.address1 = "Ingresa tu calle y número.";
  if (!bt.locality || bt.locality.trim().length < 2) errores.locality = "Ingresa tu ciudad o localidad.";
  const pais = (bt.country || "").trim().toUpperCase();
  const estado = (bt.administrativeArea || "").trim().toUpperCase();
  if (pais === "MX") {
    if (!CODIGOS_ESTADO_MX.has(estado)) errores.administrativeArea = "Selecciona tu estado.";
  } else if (!/^[A-Z]{2,3}$/.test(estado)) {
    errores.administrativeArea = "Usa el código del estado o provincia (2-3 letras).";
  }
  if (!/^\d{4,10}$/.test((bt.postalCode || "").trim())) errores.postalCode = "Código postal inválido.";
  if (!/^[A-Za-z]{2}$/.test((bt.country || "").trim())) errores.country = "Selecciona el país.";
  return errores;
};
